<template>
  <div class="row py-2 border-top border-skyblue">
    <div class="col-sm-5">
      <div class="row mt-1 mb-3">
        <div class="col-6 col-md-12">
          <AddServiceModal />
        </div>
      </div>
      <div class="row">
        <div class="col-sm-2 pr-0">
          <label>Glosa:</label>
        </div>
        <div class="col-sm-4 pl-0">
          <input id="checkGlosa"
           v-model="glosaTipo"
           class="form-check-input"
           type="checkbox">
          <label class="form-check-label"
           for="checkGlosa">
            Privado
          </label>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <textarea
           v-model="glosa"
           class="form-control"
           placeholder="Ingrese alguna descripcion de la venta"
           rows="3"></textarea>
        </div>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="row mb-4"></div>
      <div class="row mb-2">
        <div class="col-sm-3 px-0">
        </div>
        <div class="col-12 col-md-4" v-show="!seguroDobleSelected">
          <FormaPagoModal />
        </div>
        <div class="col-sm-3" v-if="islistaTablaVacia === false
          && !seguroDobleSelected && totalVenta > 0">
          <b-badge pill variant="secondary p-2 mx-1 mb-1"
           v-for="(item, index) in getListaBadges" :key="index"
           >
            {{item.nombre}}
            <br>
            <template v-if="item.numero_tarjeta">
              Num Tarjeta: {{ item.numero_tarjeta }}
            </template>
          </b-badge>
        </div>
      </div>
    </div>
    <div class="col-sm-3 pl-0">
      <div class="row mb-2" v-if="isDisableSeguro">
        <div class="col-sm-6 text-right">
          <label class="col-form-label">
            <b>Sub Total:</b>
          </label>
        </div>
        <div class="col-sm-6 pl-0">
          <div class="div-input">{{getSubTotal | numeral('0,0.00')}}</div>
        </div>
      </div>
      <div class="row" v-if="isDisableSeguro">
        <div class="col-sm-6 text-right">
          <label class="col-form-label">
            <b>- Seguro:</b>
          </label>
        </div>
        <div class="col-sm-6 pl-0">
          <div class="div-input">{{totalSeguro | numeral('0,0.00')}}</div>
        </div>
      </div>
      <template v-if="hasPermisionDecuento">
        <!-- BAJO PRIVILEGIOS EXTRA -->
        <div class="row mb-1 th-custom-color py-2">
          <div class="text-right col-sm-6">
            <h4 class="pt-1 text-dark">
              <b>Sub Total:</b>
            </h4>
          </div>
          <div
            class="col-sm-6 pl-0"
          >
            <div class="div-input bg-main">{{(getSubTotal) | numeral('0,0.00')}}</div>
          </div>
        </div>
              <!-- descuento general  BAJO EXTRA BLOQUAR CUANDO SE PREFACTURA -->
      <div class="row mb-1">
        <div class="col-sm-6 text-right">
          <input type="checkbox" class="label_descuento"
          :disabled="disabledDescuentoGral"
          v-model="descuentoGeneral" @change="clearDescuentoUnitario">(-)Desc:
        </div>
        <div class="col-sm-6 pl-0">
          <div class="div-input" v-if="!descuentoGeneral">{{ totalDescuento | numeral('0,0.00') }}</div>
          <vue-numeric class="form-control" v-model="descuento" separator=","
            :precision="2"
            style="text-align: end"
            :max="totalVenta"
            :disabled="disabledDescuentoGral"
            v-on:input.native="limpiarFormaPago"
            v-else
          />
        </div>
      </div>
      </template>
      <div class="row mb-2 th-custom-color py-2 "
        :class="hasSeguroDoble && has_active_doble_seguro && seguroDobleSelected ? 'custom-row-total' : ''"
      >
        <div
          v-if="hasSeguroDoble && has_active_doble_seguro && seguroDobleSelected"
          class="col-sm-4 pl-2 pr-0 pb-2 d-flex align-items-center"
        >
          <button
            class="btn btn-sm text-uppercase "
            :class="claseAlineacionSeguro"
            style="font-size: 10px; height: auto; min-height: 26px; width: 100%; border: 1px solid black;
                  background-color: #2efe9a; color: black; white-space: normal; word-break: break-word;
                  text-align: left; padding-left: 6px;"
            @click="cambiarSeguroDoble()"
          >
            {{ seguroDobleSelected.nombre }}
          </button>
        </div>

        <div class="text-right"
          :class="hasSeguroDoble && has_active_doble_seguro && seguroDobleSelected ? 'col-sm-3 custom-pr-total' : 'col-sm-6'"
        >
          <h4 class="pt-1 text-dark">
            <b>Total:</b>
          </h4>
        </div>
        <div
          :class="hasSeguroDoble && this.has_active_doble_seguro && seguroDobleSelected ? 'col-sm-5 pl-1':'col-sm-6 pl-0'"
        >
          <div class="div-input bg-main">{{(totalVenta) | numeral('0,0.00')}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 offset-sm-6 pl-0">
          <button class="btn btn-warning col-sm-12"
            @click="guardarFormulario"
            :disabled="buttonDisabled">
            <span
              v-if="buttonDisabled"
              class="spinner-border spinner-border-sm mr-1"
              role="status"
              aria-hidden="true"
            ></span>
            Guardar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/modules/common/axiosERP';
import { MODALIDAD_FACTURACION } from '@/utils/globalConventions';
import VueNumeric from 'vue-numeric';
import privilegios from '@/plugins/privilegios/index';
import { util } from '@/plugins/util';
import {
  mapGetters,
  mapActions,
  mapMutations,
  mapState,
} from 'vuex';
import { mapFields } from 'vuex-map-fields';
import AddServiceModal from './AddServiceModal.vue';
import FormaPagoModal from './FormaPagoModal.vue';

export default {
  name: 'DetalleFactura',
  components: {
    FormaPagoModal,
    AddServiceModal,
    VueNumeric,
  },
  data() {
    return {
      buttonDisabled: false,
      isDisableSeguro: false,
      has_active_doble_seguro: false,
    };
  },
  created() {
    const funcionalidadId = this.funcionalidadAccions.SEG_LISTAR.funcionalidad_id;
    const funcionalidadAccion = this.funcionalidadAccions.SEG_LISTAR.accion;
    this.isDisableSeguro = this.existePrivilegios(funcionalidadId, funcionalidadAccion);
    this.getParametrosOtros();
  },
  mixins: [privilegios],
  methods: {
    cambiarSeguroDoble() {
      // Filtramos solo los que tienen aseguradora_doble_id válido
      const lista = (this.getSeguroMedico ?? []).filter(
        (s) => s.aseguradora_doble_id,
      );
      if (lista.length === 0) return;

      const actualId = this.seguroDobleSelected?.id ?? null;

      // Buscar el índice actual
      const actualIndex = lista.findIndex(
        (s) => s.aseguradora_doble_id === actualId,
      );

      // Calcular el siguiente (modo ruleta)
      const nextIndex = (actualIndex + 1) % lista.length;

      const nextItem = lista[nextIndex];
      const nextId = nextItem.aseguradora_doble_id;

      // Buscar el objeto completo en getFilteredAseguradora
      this.seguroDobleSelected = this.getFilteredAseguradora.find(
        (item) => item.id === nextId,
      );
    },
    redirect(path) {
      this.$router.push(path);
    },
    async store() {
      if (this.getPacienteSelected === null) {
        util.showNotify('Elija un Paciente', 'warn');
        return;
      }
      if (this.checkFacturaTercero && this.isTipoFacturaManual) {
        if (this.nroFactura === null || this.nroFactura === '') {
          util.showNotify('Indique el numero de la Factura', 'warn');
          return;
        }
      }
      if (this.caja + this.banco + this.tarjeta > this.getSubTotal) {
        util.showNotify('el monto de pago es superior al subTotal', 'warn');
        return;
      }
      this.buttonDisabled = true;
      const { STORE_OK, ventaId } = await this.callStoreApi();
      if (STORE_OK) {
        this.redirect(this.getPathForRedirect(ventaId));
      }
      this.buttonDisabled = false;
    },
    getPathForRedirect(ventaId) {
      if (this.isTipoFacturaComputarizada) {
        return { name: 'facturacion-print', params: { id: btoa(ventaId) } };
      }
      return { name: 'facturacion-index' };
    },
    async update() {
      if (this.getPacienteSelected === null) {
        util.showNotify('Elija un Paciente', 'warn');
        return;
      }
      if (this.caja + this.banco + this.tarjeta > this.getSubTotal) {
        util.showNotify('el monto de pago es superior al subTotal', 'warn');
        return;
      }
      this.buttonDisabled = true;
      const id = atob(this.$route.params.id);
      const UPDATE_OK = await this.callUpdateApi(id);
      if (UPDATE_OK) {
        this.redirect({ name: 'facturacion-index' });
      }
      this.buttonDisabled = false;
    },
    guardarFormulario() {
      if (this.isEnabledFormaPago === false) {
        util.showNotify('Ingrese forma de pago!', 'warn');
        return;
      }
      if (this.checkSeguroEstado && parseFloat(this.totalSeguro) <= 0) {
        util.showNotify('Ingrese un servicio con seguro!', 'warn');
        return;
      }
      if (this.getModoEdicion) {
        this.update();
      } else {
        this.store();
      }
    },
    ...mapActions('facturacion', [
      'callStoreApi',
      'callUpdateApi',
    ]),
    async getParametrosOtros() {
      try {
        const response = await axios.get('/clinic/parametros/other/create');
        this.has_active_doble_seguro = response.data.data.has_active_doble_seguro;
      } catch (error) {
        util.showNotify(error.response.data.message, 'error');
      }
    },
    resetearFacturacion() {
      this.setNroFactura(null);
      this.resetDatosAddServiceModal();
      this.resetTableAndAddService();
      this.resetDetalleFactura();
      this.resetDatosFormaPagoModal();
      this.resetFormaPagoFacturaTercero();
    },
    selectDobleSeguro() {
      this.resetearFacturacion();
    },
    removeDobleSeguro() {
      this.getServiciosApi();
    },
    ...mapMutations('formFactura', [
      'setNroFactura',
    ]),
    ...mapActions('addServiceModal', [
      'resetDatosAddServiceModal',
      'getServiciosApi',
    ]),
    ...mapActions('tableAndAddService', [
      'resetTableAndAddService',
    ]),
    ...mapActions('detalleFactura', [
      'resetDetalleFactura',
      'limpiarDescuentoUnitario',
      'actualizarSubTotal',
    ]),
    ...mapActions('formaPagoModal', [
      'resetDatosFormaPagoModal',
      'clearFormaPagoCajas',
      'resetAjustesModal',
    ]),
    ...mapActions('formaPagoFacturaTercero', [
      'resetFormaPagoFacturaTercero',
    ]),
    clearDescuentoUnitario() {
      if (!this.descuentoGeneral) {
        this.limpiarDescuentoUnitario();
      }
      this.limpiarFormaPago();
    },
    limpiarFormaPago() {
      this.clearFormaPagoCajas();
      this.monto1 = this.totalVenta;
      this.listaBadges = [];
      this.resetAjustesModal();
    },
  },
  computed: {
    ...mapGetters('tableAndAddService', [
      'islistaTablaVacia',
    ]),
    ...mapFields('formFactura', [
      'checkSeguroEstado',
      'nroFactura',
      'checkFacturaTercero',
      'aseguradoraSelected',
      'tipo_factura',
      'checkValorCero',
      'numeroTratamiento',
    ]),
    ...mapFields('formaPagoFacturaTercero', [
      'caja',
      'banco',
      'tarjeta',
    ]),
    ...mapFields('detalleFactura', [
      'glosa',
      'glosaTipo',
      'totalSeguro',
      'seguroDobleSelected',
      'descuentoGeneral',
      'descuento',
      'listaBadges',
    ]),
    ...mapFields('main', [
      'funcionalidadAccions',
    ]),
    ...mapGetters('facturacion', [
      'getModoEdicion',
    ]),
    ...mapGetters('formFactura', [
      'getCheckSeguroEstado',
      'getPacienteSelected',
      'isTipoFacturaManual',
      'isTipoFacturaComputarizada',
      'getComboAseguradora',
      'getSeguroMedico',
    ]),
    ...mapGetters('formaPagoModal', [
      'isEnabledFormaPago',
    ]),
    ...mapGetters('detalleFactura', [
      'getSubTotal',
      'getTotal',
      'getListaBadges',
      'getTotalSeguroDoble',
      'getTotalDescuento',
    ]),
    getFilteredAseguradora() {
      if (this.aseguradoraSelected !== null) {
        return this.getComboAseguradora.filter((item) => (
          item.id !== this.aseguradoraSelected.id
        ));
      }
      return this.getComboAseguradora;
    },
    hasSeguroDoble() {
      const tieneDoble = this.aseguradoraSelected && this.aseguradoraSelected.aseguradora_doble_id !== null;

      return (
        (this.aseguradoraSelected != null && this.getCheckSeguroEstado && this.checkValorCero && this.tipo_factura === MODALIDAD_FACTURACION.SIN_FACTURA) || tieneDoble
      );
    },
    totalVenta() {
      // const descuento = this.descuentoGeneral ? parseFloat(this.descuento) : this.totalDescuento;
      if (this.seguroDobleSelected) {
        return this.getTotalSeguroDoble;
      }
      return this.getTotal;
    },
    totalDescuento() {
      return this.getTotalDescuento;
    },
    disabledDescuentoGral() {
      let desc = false;
      if (this.tipo_factura === MODALIDAD_FACTURACION.PREVENTA
          || this.medicoSelected || this.aseguradoraSelected
          || this.checkValorCero
      ) {
      // Se añadira esto en el if para bloquear descuento si viene de internacion
        /*  || this.getNumeroItemChecked !== ''
          || this.numeroTratamiento !== null */

        desc = true;
      }
      return desc;
    },
    ...mapGetters('main', [
      'hasPermisionDecuento',
    ]),
    ...mapGetters('modalTratamientoEnCurso', [
      'getNumeroItemChecked',
    ]),
    ...mapState('formFactura', [
      'medicoSelected',
    ]),
    ...mapFields('formaPagoModal', [
      'monto1',
    ]),
    claseAlineacionSeguro() {
      if (!this.seguroDobleSelected || !this.seguroDobleSelected.nombre) return 'text-center';
      return this.seguroDobleSelected.nombre.length > 20 ? 'text-left pl-2' : 'text-center';
    },
  },
  watch: {
    descuento() {
    },
    getSeguroMedico(newVal) {
      if (!this.seguroDobleSelected && Array.isArray(newVal) && newVal.length > 0) {
        const itemConDoble = newVal.find((item) => item && item.aseguradora_doble_id);
        if (itemConDoble) {
          const seguro = this.getFilteredAseguradora.find(
            (aseg) => aseg.id === itemConDoble.aseguradora_doble_id,
          );
          if (seguro) {
            this.seguroDobleSelected = seguro;
          }
        }
      }
    },
    aseguradoraSelected(newVal) {
      if (!newVal) return;

      if (this.hasSeguroDoble) {
        if (newVal.aseguradora_doble_id !== null) {
          const resultado = this.getComboAseguradora.find(
            (item) => item.id === newVal.aseguradora_doble_id,
          );
          if (resultado) {
            this.seguroDobleSelected = resultado;
            this.has_active_doble_seguro = true;
            this.tipo_factura = MODALIDAD_FACTURACION.SIN_FACTURA;
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.border-skyblue {
  border-color: #61c6f2 !important;
}
.div-input {
  outline: initial !important;
  border: 1px solid #ced4da;
  color: #474d6d;
  background-color: rgb(238, 238, 238);
  opacity: 1;
  display: block;
  width: 100%;
  height: calc(1.9695rem + 2px);
  padding: .375rem .75rem;
  font-size: .813rem;
  line-height: 1.5;
  background-clip: padding-box;
  border-radius: .25rem;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}
.custom-row-total {
  width: 411px;
  transform: translateX(-97px);
}
.custom-pr-total {
  padding-right: 0.67rem;
}
</style>
